import React from 'react';
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

import { makeRandomColorRGB } from '../../util/rotinas';

Chart.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const BarChart = ({ title, dados }) => {
  const options = {
    plugins: {
      title: {
        display: true,
        text: title.toUpperCase(),
        font: {
          size: 16
        }

      },
      subtitle: {
        display: true,
        text: '* Clique nos labels abaixo para manipular a exibição',
        position: 'bottom',
        padding: '10',
      },
      legend: {
        position: 'left',
      },
    },
    responsive: true,
    interaction: {
      mode: 'point',
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };

  const labels = dados.map(item => item.fantasy_name);
  const data_shipay = dados.map(item => item.SHIPAY_ITAU ? item.SHIPAY_ITAU : 0)
  const data_matera = dados.map(item => item.MATERA ? item.MATERA : 0)
  const data_bb = dados.map(item => item.BB ? item.BB : 0)

  const data = {
    labels,
    datasets: [
      {
        label: 'SHIPAY',
        data: data_shipay,
        backgroundColor: makeRandomColorRGB(),
        stack: 'Stack 0',
      },
      {
        label: 'MATERA',
        data: data_matera,
        backgroundColor: makeRandomColorRGB(),
        stack: 'Stack 0',
      },
      {
        label: 'BANDO DO BRASIL',
        data: data_bb,
        backgroundColor: makeRandomColorRGB(),
        stack: 'Stack 0',
      },
    ],
  };

  return (
    <div >
      <Bar options={options} data={data} height={150} />
    </div>
  );
}
